<template>
  <section class="features-area ptb-70 bg-f6f4f8">
    <div class="container">
      <div class="section-title">
        <h2>Overall Service Benefits</h2>
       
        <p>
          IRecharge Pay gives numerous benefits to our customers!!!
        </p>
      </div>
      <div class="row">
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon">
              <i class="flaticon-settings"></i>
            </div>
            <h3>Same day remittance</h3>
            <p>
            iRechargePay offers same day remittance to solve the problem of liquidity for most small and medium sized businesses. Collected funds can are credited within the same day to ensure speedy transactions, productive business relationships and hassle free services. With same day remittances, you are guaranteed more cash in hand for your business, hence more volume.  
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon bg-f78acb">
              <i class="flaticon-envelope-of-white-paper"></i>
            </div>
            <h3>Email notifications</h3>
            <p>
              For easy tracking and confirmation of settlement, an automated email receipt is sent to the merchant as soon as the collection is confirmed.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon bg-cdf1d8">
              <i class="flaticon-menu"></i>
            </div>
            <h3>Robust dashboard with analytics</h3>
            <p>
              Our dashboard is designed to provide a birds eye view of transactions, with display features of sales analysis and performance reports to provide easy monitoring.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon bg-c679e3">
              <i class="flaticon-info"></i>
            </div>
            <h3>Customer Retention</h3>
            <p>
              Our customers are our brand ambassadors because we have been able to form lasting relationships with them making them loyal to our products and services. 
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon bg-eb6b3d">
              <i class="flaticon-cursor"></i>
            </div>
            <h3>Multiple Access Channels</h3>
            <p>
              Merchants enjoy maximum flexibility by switching access from both mobile and desktop simultaneously without any restrictions.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon">
              <i class="flaticon-alarm"></i>
            </div>
            <h3>Instant Confirmation</h3>
            <p>
              Enjoy instant payment verification. As we aim to provide a safe and secure platform, an instant verification feature is provided for merchant to verify concluded payments. Simply click on "confirm payment" to very status within minutes.
            </p>
          </div>
        </div>

         <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon">
              <i class="flaticon-alarm"></i>
            </div>
            <h3>Audit trail and Transaction History Reporting</h3>
            <p>
              Merchants can access and generated transactions summary for any period via mobile and Desktop Application, for easy tracking and auditing a comprehensive report will be sent to merchant on daily, weekly, or monthly basis depending on the scheduled period of delivery.  
            </p>
          </div>
        </div>

         <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon">
              <i class="flaticon-alarm"></i>
            </div>
            <h3>Print, Save and Download features</h3>
            <p>
              iRechargePay offers same day remittance to solve the problem of liquidity for most small and medium sized businesses. Collected funds can are credited within the same day to ensure speedy transactions, productive business relationships and hassle free services. With same day remittances, you are guaranteed more cash in hand for your business, hence more volume.
            </p>
          </div>
        </div>

         <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="single-features-box">
            <div class="icon">
              <i class="flaticon-alarm"></i>
            </div>
            <h3>Dedicated customer Support 24/7</h3>
            <p>
              Lorem ipsum dolor amet, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna
              aliqua.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.single-features-box {
  height: 400px;
}
</style>